import { apiRequest} from './index'

export const getInstanceLogsRequest = (instanceName, instanceId) => {
  return apiRequest(
    `/admin/logs/instance/${instanceName}/${instanceId}`,
    {
      method: 'GET'
    },
    true
  )
}

export const createLogRequest = (data) => {
  return apiRequest(
    `/admin/logs`,
    {
      method: 'POST',
      body: JSON.stringify(data)
    },
    true
  )
}